export default "__VITE_ASSET__8eec6741__"